export default {
    heading: 'Add discount',
    discount: 'Discounts',
    discount_title: 'Discount',
    title: {
        label: 'Discount title',
        placeholder: 'Enter discount title',
    },
    date_from: {
        label: 'From date',
        placeholder: 'enter from date',
    },
    date_to: {
        label: 'To date',
        placeholder: 'Enter to date',
    },
    percentage: {
        label: 'Percentage',
        placeholder: 'Enter percentage',
    },
    price: {
        label: 'New price',
        placeholder: 'Enter new price',
    },
    offer: {
        label: 'Service',
        placeholder: 'Choose service',
    },
    category: {
        label: 'Categories',
        placeholder: 'Choose categories',
    },
    table: {
        offer: 'Service',
        category: 'Category',
        title: 'Title',
        date_from: 'Date from',
        date_to: 'Date to',
        percentage: 'Percentage',
        actions: 'Actions',
    },
    discount_info: 'Discount will apply for all reservations made in configured time range.',
    delete_discount: 'Are you sure you want to delete discount?',
    warning: 'There is no discounts currently!',
}
